import { insertBefore } from "../utils/manipulation";

const widgets = document.querySelectorAll(".js-form-pros-cons");
[...widgets].forEach(widget => {
	widget.addEventListener("keydown", onKeyDownHandler, false);
});

function onKeyDownHandler(e) {
	const container = e.target.parentNode.parentNode;
	if (e.key.toLowerCase() === "enter") addField.call(container, e);
	if (e.key.toLowerCase() === "backspace") removeField.call(container, e);
}

function addField(e) {
	e.stopPropagation();
	e.preventDefault();
	const input = e.target;
	const field = input.parentNode;
	const newField = field.cloneNode(true);
	input.value = "";
	insertBefore(newField, field);
}

function removeField(e) {
	const input = e.target;
	if (this.children.length > 1 && !input.value) {
		const field = input.parentNode;
		const prevInput = field.previousSibling.querySelector("input");
		prevInput.focus();
		setTimeout(() => {
			prevInput.selectionStart = prevInput.selectionEnd = 10000;
		}, 0);
		field.parentNode.removeChild(input.parentNode);
	}
}
